import { render, staticRenderFns } from "./attributeCourse.vue?vue&type=template&id=3d8eb054&scoped=true&"
import script from "./attributeCourse.vue?vue&type=script&lang=js&"
export * from "./attributeCourse.vue?vue&type=script&lang=js&"
import style0 from "./attributeCourse.vue?vue&type=style&index=0&id=3d8eb054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8eb054",
  null
  
)

export default component.exports